<template>
    <div>
        <vx-card>
            <vs-row v-if="item.salary" class="mb-2 flex justify-between head">
                <vs-col vs-lg="2" vs-sm="12" class="flex-1 flex justify-start lg:justify-end date-span-right">
                    <!-- <span class="lg:px-4 date-span mr-2 p-2">{{
                        item.period_time
                    }}</span> -->
                    <span class="px-4 wage p-2">{{ item.salary }} &#8376;</span>
                </vs-col>
            </vs-row>
            <div class="flex justify-between flex-wrap">
                <div class="infos-column mb-5">
                    <span class="subtitle-text" v-if="item.job">{{ item.job.name }}</span>
                    <span class="subtitle-text" v-else>{{ item.job }}</span>

                    <span class="break-words" v-if="item.company">В {{ item.company.name }}</span>
                    <span class="break-words" v-else>В {{ item.company }}</span>
                </div>

                <div class="vals_list mb-5">
                    <!-- <div class="flex item items-center ">
                        <div class="label font-semibold">{{ $t("wage") }}:</div>
                        <div class="value">{{ item.salary }} &#8376;</div>
                    </div> -->
                    <div v-if="item.schedule_name.name" class="flex item items-center">
                        <div class="label font-semibold">{{ $t("work_schedule") }}:&nbsp;</div>
                        <div class="value">{{ item.schedule_name.name }}</div>
                    </div>
                    <div v-if="item.required_course" class="flex item items-center">
                        <div class="label font-semibold">{{ $t("required_course") }}:&nbsp;</div>
                        <div class="value">{{ item.required_course }}</div>
                    </div>
                    <!-- <div class="flex item items-center">
                        <div class="label font-semibold">{{ $t("period_time") }}:</div>
                        <div>{{ item.period_time }}</div>
                    </div> -->
                    <div v-if="item.required_education_name" class="flex item items-center">
                        <div class="label font-semibold">{{ $t("required_education") }}:&nbsp;</div>
                        <div class="value">{{ item.required_education_name }}</div>
                    </div>
                </div>
                <vs-col vs-lg="2" vs-sm="12" class=" flex-2 mb-2 lg:mb-0">
                    <span class="px-4 date-span p-2">
                        {{  setDateFormat(item.updated)  }}
                    </span>
                </vs-col>
            </div>

            <!--<div class="column-flex">
                <span class="main-info">{{ $t("vacancy_description") }}</span>
                <span class="break-words">{{ item.vacancy_description }}</span>
            </div>-->
            <div class="submit-buttons mt-3">
                <vs-button
                    id="more-btn"
                    class="vs-con-loading__container"
                    @click="showDetailViewPopup()"
                    >{{ $t("more") }}</vs-button
                >
            </div>
        </vx-card>
        <detail-vacancy
            v-bind="DetailVacancyPopup"
            @close="closeDetailVacancyPopup"
        />
    </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import DetailVacancy from "./Popups/DetailVacancy";
export default {
    props: {
        item: Object,
    },
    data() {
        return {
            DetailVacancyPopup: {
                active: false,
                data: null,
            },
        };
    },
    components: {
        DetailVacancy,
    },
    computed: {
        ...mapGetters({
            VacancyDetail: "employment/getVacancyDetail",
        }),
    },
    methods: {
        ...mapActions({
            getVacanciesDetail: "employment/getVacanciesDetail",
        }),
        setId(type, index) {
            if (type === "more") {
                let str = `input_${ index }`;
                return str;
            }
        },
        closeDetailVacancyPopup() {
            this.DetailVacancyPopup.active = false;
        },
        async showDetailViewPopup() {
            this.$vs.loading({
                container: "#more-btn",
                scale: 0.45,
            });
            await this.getVacanciesDetail(this.item.uid);
            this.$vs.loading.close("#more-btn > .con-vs-loading");
            //this.DetailVacancyPopup.data = this.VacancyDetail;
            this.DetailVacancyPopup.data = this.item;
            this.DetailVacancyPopup.active = true;
        },
        setDateFormat(date) {
            let newDate = this.$moment(date).format("DD.MM.YYYY");
            return newDate;
        },
    },
};

</script>

<style scoped lang="scss">
@media only screen and (min-width: 1600px) {
    .date-span-right {
        justify-content: flex-end;
        display: flex;
        min-width: 300px;
    }
    .vals_list{
        width: 40%;
        .label{
            min-width: 250px;
        }

    }
}
.vals_list{
    .item{
        &:not(:last-child){
            margin-bottom: 8px;
        }
    }
}
.date-span {
    font-weight: bold;
    font-size: 12px;
    border-radius: 30px;
    background-color: #f2f1f2;
}
.button {
    padding-top: 20px;
}
.bold {
    font-weight: bold;
}
.main-info {
    font-weight: bold;
    font-size: 600;
}
.infos-column {
    display: flex;
    flex-direction: column;
}
.name-btn {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.name {
    font-size: large;
    font-weight: bold;
}
.ok-button {
    border-radius: 30px;
}
.welcone-text {
    align-items: center;
    justify-content: space-between;
    font-size: large;
    font-weight: 600;
    border-radius: 20px 20px 20px 0px;
    color: white;
    background-color: #545da7;
}
.subtitle-text {
    font-size: large;
    font-weight: 500;
    color: #545da7;
}
.subtitle-text {
    font-size: large;
    font-weight: 500;
    color: #545da7;
}
.flex-between {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.main-info {
    font-weight: bold;
    font-size: 600;
}
.column-flex {
    display: flex;
    flex-direction: column;
}
.name {
    font-size: large;
    font-weight: bold;
}
.head {
    align-items: center;
    justify-content: space-between;
}
.title-text {
    font-size: large;
    font-weight: 600;
}
.wage {
    border-radius: 30px;
    background-color: #2dcd7a;
    color: white;
    font-weight: bold;
}
</style>
